import { render, staticRenderFns } from "./applicationCertificate.vue?vue&type=template&id=2954f322"
import script from "./applicationCertificate.vue?vue&type=script&lang=js"
export * from "./applicationCertificate.vue?vue&type=script&lang=js"
import style0 from "./applicationCertificate.vue?vue&type=style&index=0&id=2954f322&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports